import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
    @Input() isOpen: boolean = false;
    @Output() isOpenChange = new EventEmitter<boolean>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isOpen'] && changes['isOpen'].currentValue) {
            document.body.style.overflow = 'hidden'; // Remove o scroll
        } else {
            document.body.style.overflow = 'auto'; // Restaura o scroll
        }
    }

    close(): void {
        this.isOpen = false;
        this.isOpenChange.emit(this.isOpen);
        document.body.style.overflow = 'auto'; // Garante que o scroll é restaurado
    }
}
